<template>
  <div class="section-component-node-subsection">
    <div class="frame-19">
      <p class="text-wrapper-8">Ce que disent nos fleuristes</p>
      <div class="frame-20">
        <div class="container-4">
          <div class="frame-21">
            <p class="text-wrapper-9">
              Florisuite a transformé la gestion de ma boutique. Tout est plus
              rapide et plus organisé, me laissant plus de temps pour ma
              passion.&#34;
            </p>
            <div class="frame-22">
              <img
                class="image-3"
                alt="Image"
                src="https://c.animaapp.com/nNxA75tB/img/image-3@2x.png"
                loading="lazy"
                decoding="async"
              />
              <div class="frame-23">
                <div class="text-wrapper-10">Sophie Dubois</div>
                <div class="text-wrapper-11">
                  Propriétaire, &#34;Fleurs de Sophie&#34;
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-4">
          <div class="frame-21">
            <p class="text-wrapper-9">
              &#34;L&#39;intégration e-commerce est un rêve! Je gère mes
              commandes en ligne et en magasin depuis une seule plateforme. Un
              gain de temps incroyable.&#34;
            </p>
            <div class="frame-22">
              <img
                class="image-3"
                alt="Image"
                src="https://c.animaapp.com/nNxA75tB/img/image-4@2x.png"
                loading="lazy"
                decoding="async"
              />
              <div class="frame-24">
                <div class="text-wrapper-10">Marc Léger</div>
                <div class="text-wrapper-11">
                  Gérant, &#34;Le Jardin Secret&#34;
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-4">
          <div class="frame-25">
            <p class="text-wrapper-9">
              &#34;Le support est fantastique. Chaque question est résolue
              rapidement, et les fonctionnalités sont intuitives, même pour
              quelqu&#39;un comme moi qui n&#39;est pas très technophile.&#34;
            </p>
            <div class="frame-26">
              <img
                class="image-3"
                alt="Image"
                src="https://c.animaapp.com/nNxA75tB/img/image-5@2x.png"
                loading="lazy"
                decoding="async"
              />
              <div class="frame-27">
                <div class="text-wrapper-10">Chloé Martin</div>
                <div class="text-wrapper-11">
                  Artisan fleuriste, &#34;L&#39;Éclosion&#34;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SectionComponentNodeSubsection",
});
</script>

<style>
.section-component-node-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafa;
  border: 0px none;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .frame-19 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 50px;
  justify-content: center;
  max-width: 1192px;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .text-wrapper-8 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
}

.section-component-node-subsection .frame-20 {
  align-items: stretch;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 31px 31px;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .container-4 {
  align-items: flex-start;
  background-color: #fafafa;
  border: 0px none;
  border-radius: 10px;
  box-shadow: 0px 0px 0px transparent, 0px 0px 2px #171a1f1f;
  display: flex;
  flex: 1 1 320px;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  padding: 24px 22px;
  position: relative;
}

.section-component-node-subsection .frame-21 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 50px;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .text-wrapper-9 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
}

.section-component-node-subsection .frame-22 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 14px;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .image-3 {
  height: 48px;
  position: relative;
  width: 48px;
}

.section-component-node-subsection .frame-23 {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .text-wrapper-10 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
}

.section-component-node-subsection .text-wrapper-11 {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
  text-align: center;
}

.section-component-node-subsection .frame-24 {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .frame-25 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 22px;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .frame-26 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 13px;
  position: relative;
  width: 100%;
}

.section-component-node-subsection .frame-27 {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
  width: 100%;
}

@media (max-width: 1024px) {
  .section-component-node-subsection {
    padding: 80px 24px;
  }

  .section-component-node-subsection .frame-19 {
    gap: 36px;
  }

  .section-component-node-subsection .text-wrapper-8 {
    font-size: 32px;
    line-height: 38px;
  }
}

@media (max-width: 768px) {
  .section-component-node-subsection {
    padding: 64px 20px;
  }

  .section-component-node-subsection .frame-20 {
    gap: 20px;
  }

  .section-component-node-subsection .container-4 {
    flex-basis: 100%;
    padding: 20px 16px;
  }

  .section-component-node-subsection .text-wrapper-8 {
    font-size: 28px;
    line-height: 34px;
  }

  .section-component-node-subsection .text-wrapper-9 {
    font-size: 16px;
    line-height: 25px;
  }
}

@media (max-width: 480px) {
  .section-component-node-subsection {
    padding: 52px 16px;
  }

  .section-component-node-subsection .text-wrapper-8 {
    font-size: 24px;
    line-height: 30px;
  }
}
</style>
